import React from 'react';
import { assest } from '../../Assest/Assest';

function DenturesBridges() {
  return (
    <div style={styles.container}>
      <img 
        src={assest.DenturesBridges}
        alt="Dentures and Bridges"
        style={styles.image}
      />
      <div style={styles.content}>
        <h2 style={styles.title}>Restore Your Smile with Dentures & Bridges</h2>
        <p style={styles.text}>
          Dentures and bridges are great solutions for people with missing teeth. Whether you are missing a single tooth or 
          multiple teeth, these restorations can help you regain a full, beautiful smile. Dentures are removable devices that 
          replace missing teeth, while bridges are fixed restorations that fill the gap between healthy teeth with artificial teeth.
        </p>
        <p style={styles.text}>
          Dentures are custom-made to fit the shape of your mouth and can be partial or complete, depending on how many teeth 
          need replacement. They are designed to restore your ability to chew, speak, and smile with confidence. For those who 
          prefer a more permanent option, dental bridges are ideal. These are anchored to your natural teeth or implants and 
          provide a sturdy, long-lasting solution for missing teeth.
        </p>
        <p style={styles.text}>
          Whether you need partial dentures, full dentures, or dental bridges, our expert team will work with you to create 
          a personalized treatment plan to restore your smile and function. Book a consultation today to explore how dentures 
          or bridges can help you smile with ease!
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#f9f9f9',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
  },
  containerHover: {
    transform: 'translateY(-10px)',
  },
  image: {
    width: '100%',
    maxWidth: '800px',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
  },
  imageHover: {
    transform: 'scale(1.05)',
  },
  content: {
    marginTop: '30px',
  },
  title: {
    fontSize: '2.5rem',
    color: '#2e2e2e',
    fontWeight: '700',
    marginBottom: '20px',
  },
  text: {
    fontSize: '1.1rem',
    color: '#555',
    lineHeight: '1.7',
    maxWidth: '800px',
    margin: '0 auto',
    paddingBottom: '10px',
    transition: 'color 0.3s ease-in-out',
  },
  textHover: {
    color: '#4caf50',
  },
};

export default DenturesBridges;
